export default function Philosophy() {
  return (
    <section id="philosophy" className="py-32 px-6 bg-[#080810] relative overflow-hidden">
      {/* Subtle grid */}
      <div className="absolute inset-0 opacity-15">
        <div className="absolute inset-0" style={{
          backgroundImage: `linear-gradient(rgba(0,255,180,0.04) 1px, transparent 1px),
                           linear-gradient(90deg, rgba(0,255,180,0.04) 1px, transparent 1px)`,
          backgroundSize: '80px 80px'
        }}></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <div className="text-xs tracking-widest text-gray-600 font-mono mb-4">
              CORE PHILOSOPHY
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-8 leading-tight text-white">
              結構決定<br />
              <span style={{ color: '#00ffb4' }}>時空概率</span>
            </h2>
            <div className="w-20 h-px mb-8" style={{ background: '#00ffb4' }}></div>
            <p className="text-sm text-gray-400 leading-relaxed mb-6">
              我們拒絕傳統諮詢模型的模糊性。每一個行為變量都被還原為精確的天文計算與統計模式。每一個參數都建立在可驗證的數學模型之上——而非主觀臆測或市場情緒。
            </p>
            <p className="text-sm text-gray-400 leading-relaxed mb-6">
              <strong className="text-white">真太陽時校正</strong>：我們根據您的精確經緯度計算真實太陽時。這種天文級時間校正確保每個時間節點參數都與真實天體力學同步——與衛星導航所使用的精度相同。
            </p>
            <p className="text-sm text-gray-400 leading-relaxed mb-6">
              <strong className="text-white">高精度地理空間錨定</strong>：位置不僅僅是座標——它是您運營環境的空間錨點。我們的系統達到四位小數精度，確保每次分析都紮根於您的實際空間背景。
            </p>
            <p className="text-sm text-gray-400 leading-relaxed">
              當基礎參數足夠精確時，預測能力呈指數級增長。這不是直覺——這是應用數學。
            </p>
          </div>

          <div className="relative">
            <div className="bg-[#0a0a0f] border border-[#00ffb4]/15 text-white p-8 rounded-lg">
              <div className="text-xs tracking-widest mb-6 text-gray-600 font-mono">
                CORE COMPUTATION PRINCIPLE
              </div>
              <div className="space-y-6">
                <div className="border-l-2 pl-4" style={{ borderColor: '#00ffb4' }}>
                  <div className="text-xs text-gray-600 mb-2 font-mono">INPUT LAYER</div>
                  <div className="font-mono text-sm text-gray-300">
                    真太陽時 = UTC + 經度偏移 + 時差方程
                  </div>
                </div>
                <div className="border-l-2 border-[#00d4ff]/60 pl-4">
                  <div className="text-xs text-gray-600 mb-2 font-mono">PROCESSING LAYER</div>
                  <div className="font-mono text-sm text-gray-300">
                    行為參數 × 統計模型 = 底層出廠設定概率
                  </div>
                </div>
                <div className="border-l-2 border-amber-400/60 pl-4">
                  <div className="text-xs text-gray-600 mb-2 font-mono">OUTPUT LAYER</div>
                  <div className="font-mono text-sm text-gray-300">
                    時空概率收斂 → PDF 戰略防禦裝甲
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-white/5">
                <div className="grid grid-cols-2 gap-4 text-center">
                  <div>
                    <div className="text-2xl font-bold mb-1" style={{ color: '#00ffb4' }}>±0.08°</div>
                    <div className="text-xs text-gray-600 font-mono">經度精度</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold mb-1" style={{ color: '#00d4ff' }}>±4min</div>
                    <div className="text-xs text-gray-600 font-mono">時間校正誤差</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="absolute -top-4 -right-4 w-24 h-24 border border-[#00ffb4]/10"></div>
            <div className="absolute -bottom-4 -left-4 w-24 h-24 border border-[#00ffb4]/10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
